// ─── Skills (from reference app.js) ───────────────────────────────────────
export const SKILLS = [
  { name: 'React Native', color: 'p', size: 170, badge: 'EXPERT' },
  { name: 'JavaScript', color: 'y', size: 150, badge: 'EXPERT' },
  { name: 'Android', color: 'm', size: 120 },
  { name: 'iOS', color: 'l', size: 120 },
  { name: 'Kotlin', color: 'p', size: 100 },
  { name: 'REST APIs', color: 'y', size: 120 },
  { name: 'SDK Integration', color: 'l', size: 130 },
  { name: 'Offline Storage', color: 'm', size: 128 },
  { name: 'SQL', color: 'p', size: 92 },
  { name: 'Git', color: 'y', size: 90 },
  { name: 'Agile / Scrum', color: 'l', size: 120 },
  { name: 'Performance', color: 'm', size: 118 },
  { name: 'Problem Solving', color: 'y', size: 128 },
  { name: 'Teamwork', color: 'p', size: 106 },
  { name: 'Client Mgmt', color: 'l', size: 110 },
  { name: 'Fast Learner', color: 'm', size: 102 },
  { name: 'Adaptability', color: 'p', size: 100 },
];

// ─── Projects (from reference portfolio.html) ──────────────────────────────
export const projects = [
  {
    id: 'ayotoko',
    name: 'Ayo Toko',
    tag: 'B2B · UMKM',
    client: 'PT SRC Indonesia Sembilan',
    role: 'Mobile Developer (React Native)',
    year: '2021 — 2022',
    subtitle: 'A pocket-size co-pilot for warung owners.',
    blurb: 'Kelontong shops in the Mitra SRC network run on thin margins and slim phones. Ayo Toko turns the counter into a dashboard — stock, pricing, orders, and sales insights in Bahasa, tuned for the kind of Android that still costs under Rp 2 juta.',
    challenge: "Shopkeepers aren't sysadmins. Interface had to feel like opening the cash register, not operating a spreadsheet.",
    did: [
      'Rebuilt the inventory & ordering flow end-to-end',
      'Offline-first catalog so transactions never block',
      'Cut cold-start below 2s on entry-level Android',
    ],
    stats: [['Platform', 'Android'], ['Audience', 'Warung owners'], ['Domain', 'Retail ops']],
    features: ['Stock tracker', 'Order book', 'Insight harian', 'Mitra rewards'],
    bg: 'linear-gradient(135deg, #ff4fa3, #b98bff)',
    accent: '#ffe066',
  },
  {
    id: 'ayohero',
    name: 'AyoHero',
    tag: 'Internal · Sales',
    client: 'PT SRC Indonesia Sembilan',
    role: 'Mobile Developer (React Native)',
    year: '2021',
    subtitle: "The salesman’s sidearm — works even when the signal doesn’t.",
    blurb: "Internal tool for SRC sales teams pitching to warungs door-to-door. They spend their day in gangs without LTE, so the app had to work like a notepad: write now, sync later, never lose a canvas.",
    challenge: "Rural cells meant ‘offline’ wasn’t a feature, it was the default mode.",
    did: [
      'Designed the local-first data layer with conflict-free sync',
      'Route planner with GPS breadcrumbs',
      'Invoice drafts that queue and fire when bars come back',
    ],
    stats: [['Platform', 'iOS'], ['Mode', 'Offline-first'], ['Users', 'SRC field sales']],
    features: ['Offline katalog', 'Route planner', 'Draft invoice', 'Smart sync'],
    bg: 'linear-gradient(135deg, #7ef5c6, #b98bff)',
    accent: '#ff4fa3',
  },
  {
    id: 'myhero',
    name: 'My Hero',
    tag: 'Next-gen · B2B2C',
    client: 'PT SRC Indonesia Sembilan',
    role: 'Mobile Developer (React Native)',
    year: '2022 — present',
    subtitle: "AyoHero, grown up. A full marketplace in your salesman’s pocket.",
    blurb: "If AyoHero was the notepad, My Hero is the whole shop. Multi-principal catalog, promo engine, shop-loyalty tiers, and analytics — packaged so a field rep sells, a warung re-orders, and HQ sees every transaction on the same rail. Still partially offline — because field signal hasn’t gotten any better.",
    challenge: 'Scale the sales app into a true commerce platform without losing the offline resilience that made AyoHero work.',
    did: [
      'Led UX refactor — faster product browse, richer detail',
      'Integrated promo/loyalty engine with tiered rewards',
      'Kept offline-first caching while adding real-time sync',
      'Perf work: trimmed bundle, lazy routes, memoised lists',
    ],
    stats: [['Platform', 'iOS'], ['Mode', 'Partially offline'], ['Domain', 'B2B marketplace']],
    features: ['Full marketplace', 'Promo engine', 'Loyalty tiers', 'Offline cache'],
    bg: 'linear-gradient(135deg, #ffe066, #ff4fa3)',
    accent: '#7ef5c6',
  },
  {
    id: 'isimpel',
    name: 'ISimpel — PPOB SDK',
    tag: 'SDK · Fintech',
    client: 'ISimpel (Indosat) → OttoDigital → me',
    role: 'SDK Engineer (Android · Kotlin)',
    year: '2023 — 2024',
    subtitle: "I didn’t build the app. I built the engine bolted inside it.",
    blurb: "ISimpel is Indosat’s productivity app for IM3 agents and outlet owners. They wanted PPOB (bill-pay, pulsa, data) baked in — fast. Indosat hired OttoDigital, OttoDigital hired PT Indoartha Perkasa Sukses, and I shipped the SDK that plugs into ISimpel like a cartridge.",
    challenge: 'Deliver a production-grade payments SDK that an existing app could drop in with one import — no UI leaks, no perf regressions.',
    did: [
      'Designed a modular Android SDK (Kotlin) with a clean public API',
      'Wrapped pulsa, data, tagihan & e-money into one flow',
      'Handoff docs + sample app so ISimpel’s team could integrate fast',
    ],
    stats: [['Platform', 'Android'], ['Language', 'Kotlin'], ['Deliverable', 'SDK']],
    features: ['Pulsa & paket data', 'Tagihan PPOB', 'E-money top-up', 'Commission tracking'],
    bg: 'linear-gradient(135deg, #b98bff, #7ef5c6)',
    accent: '#ffe066',
  },
];

// ─── About scrolly steps ──────────────────────────────────────────────────
export const aboutSteps = [
  {
    num: '01',
    title: "hi, I'm Alif.",
    body: 'Mobile developer from Jakarta. Five years shipping React Native apps for real businesses — not demos.',
  },
  {
    num: '02',
    title: 'I speak React Native.',
    body: 'Android and iOS from a single codebase — offline-first, fast, maintainable on entry-level phones.',
  },
  {
    num: '03',
    title: 'I ship for real users.',
    body: 'UMKM shopkeepers, field sales, and payment agents — not fictional personas.',
  },
  {
    num: '04',
    title: 'I love the details.',
    body: "Load times, empty states, the tiny animations nobody notices until they're gone.",
  },
];

// ─── Timeline / Experience ────────────────────────────────────────────────
export const timeline = [
  {
    date: 'FEB 2021\n→ NOW',
    color: 'var(--c-pink)',
    role: 'Mobile App Developer',
    company: 'Weekend Inc. · Kebayoran Lama',
    items: [
      'Shipped 4 production React Native apps for SRC Indonesia & OttoDigital.',
      'Ran client discovery; translated business asks into technical specs.',
      'Integrated the ISimpel PPOB SDK for payments & financial services.',
      'Cut load times with offline storage and tighter state management.',
    ],
    tags: ['React Native', 'SDK', 'REST', 'Agile'],
  },
  {
    date: 'JAN → JUL\n2019',
    color: 'var(--c-lilac)',
    role: 'Field Collection Officer',
    company: 'PT Perkasa Abadi Perdana · Tebet',
    items: [
      'Managed AR collection via structured client visits.',
      'Analysed invoice data to reduce outstanding debt timelines.',
      'Built relationships — the first lesson in client management.',
    ],
    tags: ['Data', 'Client Relations', 'Reporting'],
  },
  {
    date: '2016\n→ 2020',
    color: 'var(--c-mint)',
    role: 'B.Sc. Information Systems',
    company: 'UPN "Veteran" Jakarta · GPA 3.72',
    items: [
      'Thesis: Microservice architecture for library system resilience.',
      'Instructor, JIU-JITSU UPNVJ (2018–2019).',
      'Speaker, Seminar Nasional Pengaplikasian Telematika 2020.',
    ],
    tags: ['Thesis', 'Teaching', 'Speaking'],
  },
];

// ─── Credentials ──────────────────────────────────────────────────────────
export const credentials = [
  {
    big: true,
    ribbon: 'DEGREE',
    title: 'Bachelor of Computer Science',
    sub: 'Information Systems',
    meta: [
      { key: 'School', val: 'UPN "Veteran" Jakarta' },
      { key: 'Years', val: '2016 — 2020' },
      { key: 'GPA', val: '3.72 / 4.00' },
    ],
    thesis: 'Microservice architecture design for central library information-system resilience at UPNVJ.',
  },
  { corner: '★', color: 'var(--c-pink)', title: 'Open Source JavaScript', sub: 'Oracle Academy Webinar', date: 'Aug 2017' },
  { corner: '◆', color: 'var(--c-mint)', title: 'Differentiating U & I', sub: 'Oracle Academy Webinar', date: 'Aug 2017' },
  { corner: '✦', color: 'var(--c-lemon)', title: 'Seminar Pengaplikasian Telematika', sub: 'UPNVJ — as Speaker', date: 'Dec 2020' },
];

// ─── Fun / B-Sides ────────────────────────────────────────────────────────
export const funFacts = [
  { color: 'var(--c-pink)', icon: '🥋', title: 'Jiu-jitsu', body: 'Instructor at UPNVJ (2018–19). Still rolling on weekends.' },
  { color: 'var(--c-lilac)', icon: '🎤', title: 'Public speaking', body: 'Speaker at Seminar Nasional Telematika, 2020.' },
  { color: 'var(--c-mint)', icon: '🌐', title: 'Languages', body: 'Bahasa Indonesia — native. English — working proficiency.' },
  { color: 'var(--c-lemon)', icon: '☕', title: 'Fuel', body: 'Kopi susu, lo-fi radio, and a very organised Figma file.' },
];

// ─── Contact ──────────────────────────────────────────────────────────────
export const contactMethods = [
  { icon: '✉', key: 'email', value: 'garindra.alif@gmail.com', href: 'mailto:garindra.alif@gmail.com' },
  // { icon: '☎', key: 'phone', value: '+62 815-1369-4897', href: 'tel:+6281513694897' },
  { icon: '🔗', key: 'linkedin', value: '/in/alif-garindra', href: 'https://linkedin.com/in/alif-garindra' },
  { icon: '⌘', key: 'location', value: 'Cipete Selatan, Jakarta', href: null, meta: 'GMT+7' },
];

// ─── Legacy compat (skillsCategories used by nothing now) ─────────────────
export const skillsCategories = [];
export const skills = SKILLS.map(s => s.name);
